import { useParams, Link } from 'react-router-dom';
import { categories, animeList, type Anime } from '@/mocks/anime';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find(c => c.slug === slug) || categories[0];
  const filteredAnime: Anime[] = animeList.filter(a => a.category === slug);

  return (
    <main className="min-h-screen pt-16">
      <section className="bg-background-100 py-8 md:py-12 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">分类浏览</span>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800 font-medium">{currentCategory.name}</span>
          </nav>

          <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            {currentCategory.name}动漫
          </h1>
          <p className="text-sm text-foreground-600 mb-6">{currentCategory.description}，共{filteredAnime.length}部作品</p>

          <div className="flex items-center gap-3 flex-wrap mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>

          {filteredAnime.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {filteredAnime.map((anime) => (
                <Link
                  key={anime.id}
                  to={`/anime/${anime.slug}`}
                  className="group block"
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                    <img
                      src={anime.cover}
                      alt={anime.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      title={`${anime.title} - 樱花动漫网`}
                    />
                    <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
                      {anime.rating}
                    </div>
                    {anime.isNew && (
                      <div className="absolute top-2 right-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
                        NEW
                      </div>
                    )}
                  </div>
                  <h2 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {anime.title}
                  </h2>
                  <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                    <span>{anime.status}</span>
                    <span>&middot;</span>
                    <span>{anime.episodes}集</span>
                    <span>&middot;</span>
                    <span>{anime.year}</span>
                  </div>
                  <div className="flex flex-wrap gap-1 mt-1.5">
                    {anime.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="text-xs bg-secondary-100 text-secondary-600 px-1.5 py-0.5 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-emotion-sad-line text-foreground-300 text-4xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无动漫资源，请查看其他分类</p>
              <Link to="/" className="inline-block mt-4 text-sm text-primary-600 hover:text-primary-700">返回首页</Link>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}